import * as Yup from 'yup'
import { Formik, FormikHelpers } from 'formik'
import FormikRadioGroup from '@ui-components-3/compat/lib/components/FormikRadioGroup'
import useDocumentTitle from 'hooks/useDocumentTitle'
import TestIds from 'util/TestIds'
import EntryFormCard from '../EntryFormCard'
import { GenerateMfaSchema, GenerateMfaValues } from 'schemas/GenerateMfaSchema'
import { useTranslation } from 'react-i18next'

export type GenerateMfaSceneProps = {
  onSubmit: (values: GenerateMfaValues, form: FormikHelpers<GenerateMfaValues>) => void
  onBack: () => void
  options: Record<string, string>[]
}

const GenerateMfaScene = (props: GenerateMfaSceneProps) => {
  const { onSubmit, onBack, options = [] } = props
  useDocumentTitle('Login Mfa')
  const { t } = useTranslation()

  return (
    <EntryFormCard prompt={'MFA Required'}>
      <p className="typography-body self-start pb-4 text-start text-neutral-600">{t('common.requiredFields')}</p>
      <Formik initialValues={{ deliveryMethod: '' }} validationSchema={GenerateMfaSchema} onSubmit={onSubmit}>
        {(renderProps) => {
          const { dirty, isValid, handleSubmit } = renderProps
          return (
            <form onSubmit={handleSubmit} className="flex flex-col" data-testid={TestIds.login.form.generateMfa}>
              <FormikRadioGroup
                label={'Select an authentication method*'}
                name={'deliveryMethod'}
                options={options}
                data-testid={TestIds.login.input.generateMfa}
                columns={1}
              />
              <div className="gap-s order-3 mt-9 flex w-full items-center justify-between">
                <button
                  className="btn btn-neutral-outlined grow"
                  data-testid={TestIds.login.button.cancel}
                  onClick={onBack}
                  type="button"
                  // eslint-disable-next-line jsx-a11y/tabindex-no-positive
                  tabIndex={4}
                >
                  Back
                </button>
                <button
                  className="btn btn-primary grow"
                  data-testid={TestIds.login.button.continue}
                  disabled={!dirty || !isValid}
                  type="submit"
                  // eslint-disable-next-line jsx-a11y/tabindex-no-positive
                  tabIndex={5}
                >
                  Continue
                </button>
              </div>
            </form>
          )
        }}
      </Formik>
    </EntryFormCard>
  )
}

export default GenerateMfaScene
